import React, { useState } from 'react'

import StartPage from '../StartPage'
import Game from '../Game'

const Tetris = () => {
	const [runing, setRuning] = useState(false)

	const handleStartClick = () => {
		setRuning(true)
		window.timepass.analytics.progressionEvent({
			progressEvent: 'Start',
			progressOne: `Level_${1}`,
		})
	}
	return runing ? (
		<Game stopClick={() => setRuning(false)} />
	) : (
		<StartPage startClick={handleStartClick} />
	)
}

export default Tetris
